export default __webpack_public_path__ + "static/media/logo.f1956189864f889be488502ded10a254.svg";